import React, { useEffect, useState } from 'react'
import AxiosInstance from '../../../Helper/AxiosInstance'
import { PageHeader, TableWrap, EmptyState } from '../../../Shared/DashboardUI'

export default function AllMember() {
    const [data, setData] = useState([])
    const fetchData = async () => {
        try {
            const response = await AxiosInstance.get('/report?type=allmember')
            if (response.status === 1) { setData(response.data) }
        } catch (err) {

        }
    }
    useEffect(() => { fetchData() }, [])
    return (<>
        <PageHeader title="All Members" />
        <TableWrap>
            <thead>
                <tr>
                    <th>#</th><th>User Id</th><th>DOJ</th><th>DOA</th>
                    <th>Join Type</th><th>Level</th><th>Open Rank</th><th>Status</th>
                </tr>
            </thead>
            <tbody>
                {(data || []).length === 0 ? (
                    <tr><td colSpan="8"><EmptyState /></td></tr>
                ) : (data || []).map((tr, ind) => (
                    <tr key={tr.regno || ind}>
                        <td>{(ind + 1).toString().padStart(2, 0)}</td>
                        <td>{tr.regno}</td>
                        <td>{tr.doj}</td>
                        <td>{tr.activedate}</td>
                        <td>{tr.jointype}</td>
                        <td>{tr.levelno}</td>
                        <td>{tr.oprank}</td>
                        <td>{tr.PaidUnpaid}</td>
                    </tr>
                ))}
            </tbody>
        </TableWrap>
    </>)
}
